import { Tooltip, Button } from 'shared-ui';

import { ReactComponent as TrashDisabledIcon } from 'assets/icons/trash-disabled.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { Functionality } from 'api/userPermissions/userPermissions.enum';
import { usePermissions } from 'hooks/usePermissions/usePermissions';

import { DeleteScheduleTerminalsProps } from './DeleteScheduleTerminals.types';

const SINGLE_CONTENT = {
  title: 'schedule.terminals.delete.single.title',
  subtitle: 'schedule.terminals.delete.single.subtitle',
  text: 'schedule.terminals.delete.single.text',
} as const;

const MULTI_CONTENT = {
  title: 'schedule.terminals.delete.multi.title',
  subtitle: 'schedule.terminals.delete.multi.subtitle',
  text: 'schedule.terminals.delete.multi.text',
} as const;

export const DeleteScheduleTerminals = ({
  checkedTerminals,
  isModalOpen,
  isMultiDelete,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
  terminalsCount,
}: DeleteScheduleTerminalsProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const { title, subtitle, text } = isMultiDelete ? MULTI_CONTENT : SINGLE_CONTENT;
  const isDeleteDisabled = terminalsCount === checkedTerminals.length;
  const isPermsDisabled = !perms?.[Functionality.HARMONOGRAMY]?.edit;
  return (
    <>
      <Tooltip
        placement="bottom-start"
        disableHoverListener={!isDeleteDisabled || !isPermsDisabled}
        title={
          isPermsDisabled
            ? formatMessage({ id: AppMessages['common.noPermissions'] })
            : formatMessage({ id: AppMessages['schedule.terminals.delete.tooltip'] })
        }
      >
        <Button
          disabled={isDeleteDisabled || isPermsDisabled}
          variant="outlined"
          color="primary"
          size="medium"
          startIcon={isDeleteDisabled || isPermsDisabled ? <TrashDisabledIcon /> : <TrashIcon />}
          onClick={onModalOpen}
        >
          {formatMessage({ id: AppMessages['schedule.terminals.delete.button'] })}
        </Button>
      </Tooltip>
      <ActionModal
        size="medium"
        header={formatMessage({ id: AppMessages[title] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['schedule.terminals.delete.button'] })}
      >
        <>
          <ActionModal.Subtitle>
            {formatMessage({ id: AppMessages[subtitle] })}{' '}
            {isMultiDelete ? checkedTerminals.length : checkedTerminals[0]?.nazwa}
          </ActionModal.Subtitle>

          <ActionModal.Text>{formatMessage({ id: AppMessages[text] })}</ActionModal.Text>
        </>
      </ActionModal>
    </>
  );
};
